import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './FinalCTA.css';

const REGISTER_URL =
  "https://unstop.com/internships/campus-ambassador-internship-udghosh-1728653?lb=use17Prx&utm_medium=Share&utm_source=WhatsApp";

/* Stagger container for headline words */
const wordVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12, delayChildren: 0.1 } },
};

const wordChild = {
  hidden:  { opacity: 0, y: 40, rotateX: -20 },
  visible: { opacity: 1, y: 0, rotateX: 0, transition: { duration: 0.75, ease: [0.22, 1, 0.36, 1] } },
};

const FinalCTA = () => {
  const line1 = ["YOUR", "CAMPUS."];
  const line2 = ["YOUR", "COMMAND."];

  return (
    <section className="final-cta-section">
      {/* Ambient top gradient fade */}
      <div className="cta-top-fade" />

      <div className="final-cta-container">
        <div className="cta-content">

          {/* Eyebrow */}
          <motion.span
            className="cta-eyebrow"
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.6 }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
          >
            The Call Has Come
          </motion.span>

          {/* Main headline — staggered words */}
          <motion.h2
            className="cta-heading"
            variants={wordVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
            style={{ perspective: 600 }}
          >
            <span className="cta-headline-row">
              {line1.map((w, i) => (
                <motion.span key={i} className="cta-word" variants={wordChild}>{w}</motion.span>
              ))}
            </span>
            <span className="cta-headline-row cta-headline-gold">
              {line2.map((w, i) => (
                <motion.span key={i} className="cta-word" variants={wordChild}>{w}</motion.span>
              ))}
            </span>
          </motion.h2>

          {/* Gold rule */}
          <motion.span
            className="cta-rule"
            initial={{ scaleX: 0, opacity: 0 }}
            whileInView={{ scaleX: 1, opacity: 1 }}
            viewport={{ once: true, amount: 0.6 }}
            transition={{ delay: 0.55, duration: 0.7, ease: 'easeOut' }}
          />

          {/* Sub-heading */}
          <motion.p
            className="cta-subheading"
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ delay: 0.65, duration: 0.7, ease: 'easeOut' }}
          >
            One festival. Thousands of students. Infinite impact.<br />
            Step up and carry the torch for IIT Kanpur's biggest sports fest.
          </motion.p>

          {/* CTA */}
          <motion.div
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ delay: 0.82, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <a href={REGISTER_URL} className="cta-button" target="_blank" rel="noreferrer">
              CLAIM YOUR SPOT →
            </a>
          </motion.div>
        </div>
        <div className="cta-glow-effect"></div>
      </div>

      {/* Ambient bottom gradient fade */}
      <div className="cta-bottom-fade" />
    </section>
  );
};

export default FinalCTA;
